import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { IAmendmentPagedRequest } from '../../../model/sge/amendment/request/amendment-paged-request';
import { IAmendmentPagedResponse } from '../../../model/sge/amendment/response/amendment-paged-response';
import { IAmendmentResponse } from '../../../model/sge/amendment/response/amendment-response';

const basePath = (clientId: number) => `Public/Client/${clientId}/Amendment`;

const list = async (clientId: number, params: IAmendmentPagedRequest): Promise<Pagination<IAmendmentPagedResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId)}`,
        params
    }).then((response) => Object.assign(new Pagination<IAmendmentPagedResponse>(), response.data));
};

const getById = async (clientId: number, amendmentId: number): Promise<IAmendmentResponse> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId)}/${amendmentId}`
    }).then((response) => response.data);
};

const PublicAmendmentAppService = { list, getById };
export default PublicAmendmentAppService;
